import { useState } from 'react';
import { X } from 'lucide-react';

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '923268096371';
const WHATSAPP_MESSAGE = 'Hello! I would like to inquire about studying abroad with H E Direct Consultants.';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(true);
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 flex flex-col items-end gap-2 sm:gap-3">
      {/* Chat Tooltip - Hidden on very small screens */}
      {showTooltip && (
        <div className="hidden sm:block relative bg-white text-slate-900 px-4 py-3 rounded-lg shadow-xl max-w-[240px] animate-fade-in">
          <button 
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 w-5 h-5 bg-slate-200 hover:bg-slate-300 rounded-full flex items-center justify-center text-slate-600"
            aria-label="Close tooltip"
          >
            <X className="w-3 h-3" />
          </button>
          <p className="text-sm font-medium mb-1">Need help? Chat with us!</p>
          <p className="text-xs text-gray-400">Our team is online and ready to assist you.</p>
          {/* Arrow */}
          <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white transform rotate-45"></div>
        </div>
      )}
      
      {/* WhatsApp Button - Compact on mobile */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-3 py-2.5 sm:px-4 sm:py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group hover:scale-105 touch-manipulation"
        data-testid="whatsapp-float-btn"
        aria-label="Chat on WhatsApp"
        onClick={() => setShowTooltip(false)}
      >
        <svg 
          viewBox="0 0 24 24" 
          className="w-5 h-5 sm:w-6 sm:h-6 fill-current"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        <span className="font-medium text-sm sm:text-base hidden xs:inline">Chat</span>
        
        {/* Pulse animation */}
        <span className="absolute -top-1 -right-1 flex h-3 w-3 sm:h-4 sm:w-4">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 sm:h-4 sm:w-4 bg-green-300"></span>
        </span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
